import styled from '@emotion/styled';
import { Typography } from '@sunrun/experience-ui-components';
import { ON_INFO_SURFACE } from 'components/atoms/InfoPopover';
import { getIconForRankValue } from 'components/atoms/RankIcons';
import { NewDashboardOrgType } from 'helpers/repTypeHelper';
import { getLevelLabels } from 'helpers/runXThresholds';

const StatusLegend = ({
  orgType,
  sellsSunrun,
}: {
  orgType: NewDashboardOrgType;
  sellsSunrun: boolean;
}) => {
  const labels = getLevelLabels(orgType, sellsSunrun);

  return (
    <LegendGrid>
      {labels.map((label, index) => (
        <LegendItem key={index + 1}>
          <LegendIconWrap>
            {getIconForRankValue({ rank: index + 1, orgType })}
          </LegendIconWrap>
          <Typography
            variant="span"
            size="extra_small"
            align="center"
            color={ON_INFO_SURFACE}>
            {label}
          </Typography>
        </LegendItem>
      ))}
    </LegendGrid>
  );
};

const LegendGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.35rem;
  justify-content: space-between;
  align-items: flex-start;
`;

const LegendItem = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  text-align: center;
`;

const LegendIconWrap = styled.div`
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export { StatusLegend };
